<template>
    <span>
        <criardiario></criardiario>
    </span>
</template>

<script>
import Criardiario from '@/components/Criar-Diario';

export default {
    name: 'cadcriardiario',
    components: {
        Criardiario
    }
};
</script>